// @flow
/* eslint-disable import/prefer-default-export */
export const PDF_TEMPLATE_NAME = 'Standard PDF';
